import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Translate from 'react-translate-component';
import { Row, Col } from 'antd';
import { path, pathOr } from 'ramda';

import { APPROVAL_APPLICATION_SIDEBAR } from 'constants/sidebarTypes';
import { approvalApplications } from 'constants/routes';
import { defaultApprovalApplicationListFilters } from 'constants/defaultFilters';
import { openModalActionVacancy, openModalApplicationCancel, openModalApplicationApprove } from 'actions/modalActions';
import { TabsStatusFilter } from 'components/common/controls/TabsStatusFilter';
import RefreshButton from 'components/common/controls/RefreshButton';
import StaticTable from 'components/common/tableComponents/StaticTable';
import { SidebarLink, CheckboxCell } from 'components/common/tableComponents/cellTemplates';
import { DateTimeField } from 'components/common/fields/DateTimeFields';
import ApprovalButtons from 'components/common/controls/approvals/ApprovalButtons';
import { getSelected } from 'helpers/listHelpers';

@connect(null, { openModalActionVacancy, openModalApplicationCancel, openModalApplicationApprove })
export default class ApprovalApplicationListTable extends Component {
    static propTypes = {
        getApprovalApplicationList: PropTypes.object.isRequired,
        getApprovalApplicationListCounters: PropTypes.object.isRequired,
        openModalActionVacancy: PropTypes.func.isRequired,
        openModalApplicationCancel: PropTypes.func.isRequired,
        openModalApplicationApprove: PropTypes.func.isRequired,
        onSelect: PropTypes.func.isRequired,
        selected: PropTypes.array.isRequired,
    }

    tableColumns = [
        {
            name: 'checkbox',
            width: 40,
            additionalClass: 'table-cell-center',
            template: ({ item }) => (
                <CheckboxCell
                    selected={this.props.selected}
                    setSelected={this.props.onSelect}
                    item={item}
                    rowIndex={item.id}
                />
            )
        },
        {
            name: 'number',
            width: 60,
            additionalClass: 'p-l-15',
            template: ({ rowIndex }) => rowIndex + 1,
        },
        {
            name: 'people',
            label: <Translate content="education.approvalApplication.headers.people" />,
            template: ({ item }) => (
                <SidebarLink
                    componentName={APPROVAL_APPLICATION_SIDEBAR}
                    item={item}
                    value={path(['people', 'name'], item)}
                />
            ),
        },
        {
            name: 'vacancy',
            label: <Translate content="education.approvalApplication.headers.vacancy" />,
            template: ({ item }) => {
                const projectName = pathOr({}, ['parent', 'name'], item);
                const vacancy = pathOr({}, ['parent', 'vacancy'], item);

                return vacancy.id ? (
                    <a onClick={() => this.props.openModalActionVacancy(vacancy)}>
                        {vacancy.name}
                    </a>
                ) : projectName;
            },
        },
        {
            name: 'sender',
            label: <Translate content="education.application.headers.sender" />,
            template: ({ item }) => path(['sender', 'name'], item),
        },
        {
            name: 'datetime',
            width: 250,
            label: <Translate content="education.application.headers.datetime" />,
            template: ({ item }) => (
                <DateTimeField date={path(['send', 'date'], item)} time={path(['send', 'time'], item)} />
            ),
        }
    ];

    render() {
        const { openModalApplicationApprove, openModalApplicationCancel, selected } = this.props;
        const { data, meta, refresh } = this.props.getApprovalApplicationList;
        const { data: counters } = this.props.getApprovalApplicationListCounters;

        return (
            <div>
                <Row>
                    <div className="table-first-controls">
                        <ApprovalButtons
                            selected={selected}
                            approve={openModalApplicationApprove && (() => openModalApplicationApprove(getSelected(selected, data))) }
                            reject={openModalApplicationCancel && (() => openModalApplicationCancel(getSelected(selected, data))) }
                        />
                    </div>
                </Row>
                <Row className="react-table-controls list-controls">
                    <Col span={18}>
                        <TabsStatusFilter
                            counters={counters}
                            defaultFilters={defaultApprovalApplicationListFilters}
                            route={approvalApplications}
                            translate='approvalApplications'
                        />
                    </Col>
                    <Col span={6} className="text-right icon-bar">
                        <RefreshButton refreshMeta={meta} handleRefresh={refresh} />
                    </Col>
                </Row>
                <div>
                    <StaticTable
                        meta={meta}
                        refresh={refresh}
                        className="width-auto-table approval-table"
                        columns={this.tableColumns}
                        items={data}
                    />
                </div>
            </div>
        );
    }
}
